export const environment = {
  production: false,
  // In dev these are proxied to the backend (see proxy.conf.json).
  apiBase: '/api',
  socketUrl: '', // same-origin; socket.io path is /ws
};
